import { useNotification } from "../Contexts/NotificationContext";

export const useCopyToClipboard = () => {
  const { showNotification } = useNotification();

  const copyToClipboard = (text) => {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        showNotification(`Copied: ${text}`, "success");
      })
      .catch((err) => {
        showNotification("Failed to copy text", "error");
      });
  };

  return copyToClipboard;
};
